export default __webpack_public_path__ + "static/media/7.e58b47a1.jpg";